import React from "react";

const mdmFields = [
  { key: "mdm_code", label: "MDM Code" },
  { key: "mdm_existing_dc", label: "Existing DC" },
  { key: "mdm_division_code", label: "Division Code" },
  { key: "mdm_division_name", label: "Division Name" },
  { key: "mdm_segment_name", label: "Segment Name" },
  { key: "mdm_family_name", label: "Family Name" },
  { key: "mdm_family_code", label: "Family Code" },
  { key: "mdm_class_name", label: "Class Name" },
  { key: "mdm_class_code", label: "Class Code" },
  { key: "mdm_item_type", label: "Item Type" },
  { key: "mdm_uom", label: "UOM" },
  { key: "mdm_pack_size", label: "Pack Size" },
  { key: "mdm_dosage_from", label: "Dosage Form" },
  { key: "mdm_costing_method", label: "Costing Method" },
  { key: "mdm_batch", label: "Batch" },
  { key: "mdm_expiry_date", label: "Expiry Date" },
  { key: "mdm_expiry_shelf_life", label: "Expiry Shelf Life" },
  { key: "mdm_description1", label: "Description 1" },
  { key: "mdm_description2", label: "Description 2" },
  { key: "mdm_description3", label: "Description 3" },
  { key: "mdm_description4", label: "Description 4" },
  { key: "mdm_description5", label: "Description 5" },
  { key: "mdm_description6", label: "Description 6" },
  { key: "mdm_rating", label: "Rating" },
];

const MdmTab = ({ values }) => {
  const hasData = mdmFields.some((f) => values?.[f.key]);

  return (
    <div className="px-5 xl:px-10 mt-3">
      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "20px",
          backgroundColor: "#fafafa",
        }}
      >
        <h3
          style={{
            fontSize: "14px",
            fontWeight: 600,
            marginBottom: "16px",
            color: "#1f2937",
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "8px",
          }}
        >
          MDM - D365 Business Central
        </h3>
        {!hasData ? (
          <p style={{ color: "#9ca3af", fontSize: "13px" }}>
            No MDM data available. Use the "Fetch from D365" button on the
            General tab to load data.
          </p>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "12px 24px",
            }}
          >
            {mdmFields.map((field) => {
              const val = values?.[field.key];
              if (!val && val !== 0) return null;
              return (
                <div
                  key={field.key}
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      whiteSpace: "nowrap",
                      minWidth: "120px",
                    }}
                  >
                    {field.label}
                  </span>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#111827",
                      fontWeight: 500,
                      wordBreak: "break-word",
                    }}
                  >
                    {val}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MdmTab;
